import { render, staticRenderFns } from "./pengajuanIndex.vue?vue&type=template&id=238224f4"
import script from "./pengajuanIndex.vue?vue&type=script&lang=js"
export * from "./pengajuanIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports